/**
 * Attach GA Event to start course button
 */

( function () {

    const start_course_buttons = document.querySelectorAll( '.start-course' );

    for ( let button of start_course_buttons ) {
        button.addEventListener( 'click', () => {
            if ( window.ga && ga.create ) {
                ga( 'send', {
                    hitType: 'event',
                    eventCategory: 'Kurse',
                    eventAction: 'click',
                    eventLabel: courseview.title
                } );
            }
        } );
    }

} ) ();
